import { Button, Modal } from "../../../../../components/ui";
import {
  CREATE_VIEWING_ROOM,
  DELETE_VIEWING_ROOM,
  UPDATE_VIEWING_ROOM,
} from "../../../../../graphql/mutation/WarehouseSite";
import {
  getSuggestedViewingRoomIds,
  getViewingRoomAssignmentCandidates,
  getViewingRoomDeleteDescription,
} from "../helpers";
import ActiveRecordsPanel from "./ActiveRecordsPanel";
import AssignViewingRoomsForm from "./AssignViewingRoomsForm";

const VIEWING_ROOM_EXTRA_HEADERS = [
  { label: "Linked locations", name: "locationCount", type: "label" },
];

const ViewingRoomsPanel = props => {
  const {
    allViewingRooms,
    loading,
    locations,
    site,
    siteId,
    viewingRooms,
    warehouseSites,
  } = props || {};

  const candidates = getViewingRoomAssignmentCandidates({
    locations,
    siteId,
    viewingRooms: allViewingRooms,
    warehouseSites,
  });
  const suggestedCount = getSuggestedViewingRoomIds(candidates).length;

  const assignModalProps = {
    body: ({ closeModal }) => (
      <AssignViewingRoomsForm
        candidates={candidates}
        closeModal={closeModal}
        siteId={siteId}
        siteName={site?.name}
      />
    ),
    closeOnBackdrop: true,
    hideCloseButton: true,
    scale: "md",
  };

  const assignButton = (
    <Modal {...assignModalProps}>
      <Button label="Assign viewing rooms" action="default" />
    </Modal>
  );

  const notice =
    suggestedCount > 0 ? (
      <div className="mb-2 text-sm text-amber-700">
        {suggestedCount === 1
          ? "1 viewing room has"
          : `${suggestedCount} viewing rooms have`}{" "}
        locations on this site but no site of its own. Use Assign viewing
        rooms to link them here.
      </div>
    ) : null;

  return (
    <ActiveRecordsPanel
      addLabel="Add viewing room"
      createMutation={CREATE_VIEWING_ROOM}
      createMutationName="createViewingRoom"
      deleteLabel="Delete viewing room"
      deleteMutation={DELETE_VIEWING_ROOM}
      deleteMutationName="deleteViewingRoom"
      extraActions={assignButton}
      extraHeaders={VIEWING_ROOM_EXTRA_HEADERS}
      getCreateInput={values => ({ description: values.description, siteId })}
      getDeleteDescription={getViewingRoomDeleteDescription}
      loading={loading}
      notice={notice}
      records={viewingRooms}
      refetchQueries={["FetchSiteViewingRooms", "FetchSiteLocations"]}
      title="Viewing rooms"
      updateMutation={UPDATE_VIEWING_ROOM}
      updateMutationName="updateViewingRoom"
    />
  );
};

export default ViewingRoomsPanel;
